import * as yup from "yup";
import ProjectSetup from "./project-setup";




const WorkHistorySchema = yup.object().shape({
  biography: yup.string().required("Biography is required"),
  experiences: yup.array().of(
    yup.object().shape({
      title: yup.string().required("Work title is required"),
      startDate: yup.string().required("Start date is required"),
      endDate: yup.string().required("End date is required"),
      description: yup.string().required("Description is required")
    })
  ),
  projects: yup.array().of(
    yup.object().shape({
      title: yup.string().required("Project title is required"),
      role: yup.string().required("Role is required"),
      imdb: yup.string().matches(/imdb.com/, "Please enter valid IMDb url").url("The link must be a valid url").nullable(),
      description: yup.string().required("Description  is required")
    })
  ),
  linkdenURL: yup.string().matches(/linkedin.com/, "Please enter valid Linkedin url").url("The link must be a valid url").nullable(),
  portfolioURL: yup.string().url("The link must be a valid url").nullable()

})


const WorkHistoryInitialValues= {
  biography:'',
  experiences:[{
    id: 0,
    title: '',
    startDate: '',
    endDate: '',
    description: '',
  }],
  linkdenURL: '',
  portfolioURL: '',
  projects: [{
    id: 0,
    title: '',
    role: '',
    imdb: '',
    description: '',
  }]
}
const setupProfile = {WorkHistorySchema, WorkHistoryInitialValues};


export default setupProfile;